"use client";

import { useInView } from "@/hooks/use-in-view";

const INDUSTRIES = [
  { title: "Oil & Gas Equipment", icon: "/industries/oil.svg" },
  { title: "Commercial Vehicles", icon: "/industries/commercial.svg" },
  { title: "Construction Equipment", icon: "/industries/construction.svg" },
  { title: "Agricultural Equipment", icon: "/industries/agri.svg" },

  { title: "Mining Equipment", icon: "/industries/mining.svg" },
  { title: "Electrical Power Equipment", icon: "/industries/elec.svg" },
  { title: "Consumer Appliance", icon: "/industries/consumer.svg" },
  { title: "Electrical Cabinets", icon: "/industries/cabin.svg" },

  { title: "Pumps & Compressors", icon: "/industries/pump.svg" },
  { title: "Industrial Racks", icon: "/industries/hvac.svg" },
  { title: "Hardware & Fasteners", icon: "/industries/hardware.svg" },
  { title: "Lawn & Garden Equipment", icon: "/industries/lawn.svg" },

  { title: "Packaging Equipment", icon: "/industries/packaging.svg" },
];

export default function IndustriesGrid() {
  const { ref } = useInView<HTMLDivElement>({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      role="list"
      aria-label="Industries We Serve"
      className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 sm:gap-8 md:gap-10"
    >
      {INDUSTRIES.map(({ title, icon }) => (
        <article
          key={title}
          role="listitem"
          className="
            group
            bg-white
            rounded-2xl
            p-6 md:p-8
            min-h-[120px] md:min-h-[140px]
            shadow-[0_6px_18px_rgba(0,0,0,0.06)]
            hover:shadow-[0_12px_28px_rgba(0,0,0,0.09)]
            transition-all duration-300 ease-in-out
            flex flex-col items-center justify-start
          "
        >
          {/* ICON */}
          <img
            src={icon}
            alt={title}
            className="h-12 w-12 md:h-14 md:w-14 object-contain"
            draggable={false}
          />

          {/* TITLE */}
          <h3
            className="
              mt-4
              text-[13px] md:text-[14px]
              font-semibold
              text-[#111]
              text-center
              whitespace-normal
              leading-5
              max-w-[10rem] md:max-w-[12rem]
            "
            style={{ fontFamily: "Inter, Manrope, sans-serif" }}
          >
            {title}
          </h3>
        </article>
      ))}
    </div>
  );
}
